import { useTranslation } from "react-i18next";
import { Input, Select, SourceTag } from "./kit";

export const SOURCES = ["groomer_observation", "owner_report", "other_groomer_report", "professional_document"];
export const BASELINE_FIELDS = {
  coat: ["type", "length", "undercoat", "differing_areas", "tangling", "previous_haircut_care"],
  history: ["previous_procedures_known", "previous_procedures", "products_used", "known_responses", "negative_experiences"],
  circumstances: ["home_care", "tools", "owner_ability", "environment_changes"],
};
const TRI = ["previous_procedures_known"];

export function SourceSelect({ value, onChange, id, testid }) {
  const { t } = useTranslation();
  return (
    <Select id={id} data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value || null)} aria-label={t("field.source")}>
      <option value="">{t("source.choose")}</option>
      {SOURCES.map((s) => <option key={s} value={s}>{t(`source.${s}`)}</option>)}
    </Select>
  );
}

export function BaselineEditor({ group, value = {}, onChange }) {
  const { t } = useTranslation();
  const set = (f, patch) => onChange({ ...value, [f]: { value: "", unknown: true, source: null, ...(value[f] || {}), ...patch } });
  return (
    <div className="space-y-4" data-testid={`baseline-group-${group}`}>
      {BASELINE_FIELDS[group].map((f) => {
        const v = value[f] || { value: "", unknown: true, source: null };
        const id = `bl-${group}-${f}`;
        return (
          <div key={f} className="rounded-xl border bg-white/70 p-3">
            <label htmlFor={id} className="mb-1.5 block text-sm font-semibold">{t(`baseline.${f}`)}</label>
            <div className="grid gap-2 sm:grid-cols-[1fr_200px]">
              {TRI.includes(f) ? (
                <Select id={id} data-testid={`${id}-input`} value={v.unknown ? "unknown" : v.value} onChange={(e) => set(f, e.target.value === "unknown" ? { value: "", unknown: true } : { value: e.target.value, unknown: false })}>
                  <option value="unknown">{t("common.unknown")}</option>
                  <option value="yes">{t("common.yes")}</option>
                  <option value="no">{t("common.no")}</option>
                </Select>
              ) : (
                <Input id={id} data-testid={`${id}-input`} value={v.value} placeholder={t("common.unknown")} onChange={(e) => set(f, { value: e.target.value, unknown: !e.target.value })} />
              )}
              <SourceSelect testid={`${id}-source`} value={v.source} onChange={(s) => set(f, { source: s })} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function BaselineView({ group, value = {} }) {
  const { t } = useTranslation();
  return (
    <dl className="grid gap-3 sm:grid-cols-2" data-testid={`baseline-view-${group}`}>
      {BASELINE_FIELDS[group].map((f) => {
        const v = value[f] || { unknown: true };
        const shown = v.unknown ? t("common.unknown") : v.value === "yes" ? t("common.yes") : v.value === "no" ? t("common.no") : v.value;
        return (
          <div key={f} className="rounded-xl border bg-white p-3">
            <dt className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{t(`baseline.${f}`)}</dt>
            <dd data-testid={`baseline-value-${group}-${f}`} className="mt-1 flex flex-wrap items-center gap-2">
              <span className={v.unknown ? "italic text-muted-foreground" : ""}>{shown}</span>
              <SourceTag source={v.source} />
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
